/**
 * Restarts the xo-carousel autoplay interval whenever the active slide
 * changes (swipe, thumb click, keyboard, or automatic advance).
 *
 * The stock carousel uses one setInterval; after a manual swipe, the
 * next tick can fire almost immediately. Clearing and restarting matches
 * the behaviour after hover-pause (handlePause + handleAutoPlay on the
 * CarouselList instance).
 *
 * Requires the theme's <xo-carousel-list> to expose handlePause /
 * handleAutoPlay (bundled xo-webcomponents). If not present, binding is
 * skipped.
 */
(function () {
  function bindCarousel(carousel) {
    if (carousel.dataset.itsAutoplayResetBound === '1') return;
    if (!carousel.hasAttribute("xo-autoplay")) return;

    customElements.whenDefined("xo-carousel-list").then(function () {
      if (carousel.dataset.itsAutoplayResetBound === '1') return;

      var list = carousel.querySelector("xo-carousel-list");
      if (!list || typeof list.handlePause !== "function" || typeof list.handleAutoPlay !== "function") {
        return;
      }

      carousel.dataset.itsAutoplayResetBound = "1";

      carousel.addEventListener("xo:carousel:change", function () {
        list.handlePause();
        list.handleAutoPlay();
      });
    });
  }

  function initInRoot(root) {
    if (!root || !root.querySelectorAll) return;

    root
      .querySelectorAll('.shopify-section.section-image-text-slider-humm .image-text-slider-humm__carousel[xo-autoplay]')
      .forEach(bindCarousel);

    root
      .querySelectorAll('.shopify-section.section-image-text-slider-humm .image-text-slider-humm__carousel')
      .forEach(bindSwipeDirectionFix);
  }

  /**
   * xo-carousel wheel/pan direction feels inverted for this fade slider.
   * We handle horizontal wheel + pointer gestures here: one slide per gesture,
   * consistent direction for trackpad and mouse drag.
   */
  function bindSwipeDirectionFix(carousel) {
    if (carousel.dataset.itsSwipeFixBound === '1') return;
    carousel.dataset.itsSwipeFixBound = '1';

    var carouselName = carousel.getAttribute('xo-name');
    if (!carouselName) return;

    var slideCount = carousel.querySelectorAll('xo-carousel-slide:not([xo-cloned])').length;
    if (slideCount <= 1) return;

    var wheelGestureActive = false;
    var wheelUnlockTimer = null;
    var wheelGestureSign = 0;
    var lastWheelAbs = 0;
    var wheelHasDecayed = false;
    var pointerStartX = null;
    var pointerStartY = null;
    var isHorizontalPointer = null;
    var activePointerId = null;
    var lastNavAt = 0;
    var GESTURE_THRESHOLD = 30;
    var WHEEL_IDLE_MS = 120;
    var WHEEL_MIN_EVENT = 8;
    var WHEEL_DECAY_EVENT = 14;
    var WHEEL_SIGN_CHANGE_MIN = 40;
    var WHEEL_REACCEL_MIN = 40;
    var WHEEL_REACCEL_RATIO = 1.6;

    function getWheelAxis(event) {
      if (Math.abs(event.deltaX) >= Math.abs(event.deltaY) && Math.abs(event.deltaX) > 0) {
        return { isHorizontal: true, delta: event.deltaX };
      }
      if (event.shiftKey && Math.abs(event.deltaY) > 0) {
        return { isHorizontal: true, delta: event.deltaY };
      }
      return { isHorizontal: false, delta: 0 };
    }

    function goNext() {
      if (window.xoCarousel) window.xoCarousel.next(carouselName, 1);
    }

    function goPrev() {
      if (window.xoCarousel) window.xoCarousel.prev(carouselName, 1);
    }

    function navigateFromHorizontalDelta(deltaX, source) {
      if (Math.abs(deltaX) < GESTURE_THRESHOLD) return;
      if (Date.now() - lastNavAt < 300) {
        return;
      }
      lastNavAt = Date.now();
      var invertFromMouse = source === 'touch';
      var action = invertFromMouse
        ? (deltaX > 0 ? 'next' : 'prev')
        : (deltaX > 0 ? 'prev' : 'next');
      if (action === 'next') goNext();
      else goPrev();
    }

    function isInteractiveTarget(target) {
      if (!target || !target.closest) return false;
      return !!target.closest('a, button, input, textarea, select, [role="tab"], .image-text-slider-humm__thumb');
    }

    carousel.addEventListener('wheel', function (event) {
      var wheelAxis = getWheelAxis(event);
      if (!wheelAxis.isHorizontal) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (Math.abs(wheelAxis.delta) < WHEEL_MIN_EVENT) {
        if (wheelGestureActive) {
          wheelHasDecayed = true;
        }
        return;
      }
      var currentWheelAbs = Math.abs(wheelAxis.delta);
      clearTimeout(wheelUnlockTimer);
      wheelUnlockTimer = window.setTimeout(function () {
        wheelGestureActive = false;
        wheelGestureSign = 0;
        lastWheelAbs = 0;
        wheelHasDecayed = false;
      }, WHEEL_IDLE_MS);
      if (wheelGestureActive) {
        var nextSign = wheelAxis.delta > 0 ? 1 : -1;
        var allowDirectionChange = wheelGestureSign !== 0 && nextSign !== wheelGestureSign && Math.abs(wheelAxis.delta) >= WHEEL_SIGN_CHANGE_MIN;
        if (allowDirectionChange) {
          wheelGestureSign = nextSign;
          lastWheelAbs = currentWheelAbs;
          wheelHasDecayed = false;
          navigateFromHorizontalDelta(wheelAxis.delta, 'wheel');
          return;
        }
        var allowSameDirectionReaccel =
          wheelGestureSign !== 0 &&
          nextSign === wheelGestureSign &&
          Date.now() - lastNavAt > 250 &&
          currentWheelAbs >= WHEEL_REACCEL_MIN &&
          (wheelHasDecayed || currentWheelAbs >= lastWheelAbs * WHEEL_REACCEL_RATIO);
        if (allowSameDirectionReaccel) {
          lastWheelAbs = currentWheelAbs;
          wheelHasDecayed = false;
          navigateFromHorizontalDelta(wheelAxis.delta, 'wheel');
          return;
        }
        if (currentWheelAbs <= WHEEL_DECAY_EVENT) {
          wheelHasDecayed = true;
        }
        lastWheelAbs = currentWheelAbs;
        return;
      }
      wheelGestureActive = true;
      wheelGestureSign = wheelAxis.delta > 0 ? 1 : -1;
      lastWheelAbs = currentWheelAbs;
      wheelHasDecayed = false;
      navigateFromHorizontalDelta(wheelAxis.delta, 'wheel');
    }, { capture: true, passive: false });

    carousel.addEventListener('pointerdown', function (event) {
      if (isInteractiveTarget(event.target)) return;
      if (activePointerId != null) return;
      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      isHorizontalPointer = null;
      if (carousel.setPointerCapture) {
        try {
          carousel.setPointerCapture(event.pointerId);
        } catch (captureError) {
          /* ignore */
        }
      }
    }, { capture: true, passive: true });

    carousel.addEventListener('pointermove', function (event) {
      if (event.pointerId !== activePointerId || pointerStartX == null) return;
      var deltaX = event.clientX - pointerStartX;
      var deltaY = event.clientY - pointerStartY;
      if (isHorizontalPointer === null && (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10)) {
        isHorizontalPointer = Math.abs(deltaX) > Math.abs(deltaY);
      }
      if (isHorizontalPointer) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true, passive: false });

    function finishPointerGesture(event) {
      if (event.pointerId !== activePointerId || pointerStartX == null) return;
      var deltaX = event.clientX - pointerStartX;
      var wasHorizontal = isHorizontalPointer;
      activePointerId = null;
      pointerStartX = null;
      pointerStartY = null;
      isHorizontalPointer = null;
      if (carousel.releasePointerCapture) {
        try {
          carousel.releasePointerCapture(event.pointerId);
        } catch (releaseError) {
          /* ignore */
        }
      }
      if (!wasHorizontal) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      navigateFromHorizontalDelta(deltaX, event.pointerType === 'touch' ? 'touch' : 'pointer');
    }

    carousel.addEventListener('pointerup', finishPointerGesture, { capture: true, passive: false });
    carousel.addEventListener('pointercancel', finishPointerGesture, { capture: true, passive: false });
  }

  function boot() {
    initInRoot(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var el = event.target;
    if (el && el.classList && el.classList.contains("section-image-text-slider-humm")) {
      initInRoot(el);
    }
  });
})();
